<!-- 右侧联系方式 -->
<template>
  <div>
    <div class="sider-bar-container">
      <div class="sider-experience-container" @click="openForm">
        <div class="experience-pic"></div>
        <div class="experience-text">免费体验</div>
      </div>
      <div class="sider-phone-container">
        <a href="tel:4006007966" class="phone-tell"></a>
        <div class="phone-pic"></div>
        <div class="phone-text">电话咨询</div>
        <div class="phone-hover-container">
          <div class="phone-hover"></div>
          <div class="phone-number">400-600-7966</div>
        </div>
      </div>
      <div class="sider-weixin-container">
        <div class="weixin-pic"></div>
        <div class="weixin-text">微信咨询</div>
        <div class="weixin-hover-container">
          <div class="weixin-hover"></div>
          <div class="weixin-hover-txt">获取专业解决方案</div>
        </div>
      </div>
    </div>
<!--    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>-->
  </div>
</template>
<script>
import HussarForm from './HussarForm.vue';
import EventBus from '@/utils/eventBus';

export default {
  name: 'SideBar',
  data() {
    return {
      showForm: false,
    };
  },
  components: {
    HussarForm,
  },
  methods: {
    // 打开表单
    openForm() {
      EventBus.$emit('setProductNavFixed', false);
      new Promise(resolve => {
        setTimeout(resolve, 500);
      }).then(() => {
        this.$emit('openForm');
      });
    },
    // 关闭表单
    // closeForm() {
    //   const self = this;
    //   self.showForm = false;
    // },
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/include/SideBar.vue